export default function ItemSizeModal({
  open,
  item,
  sizes = [],
  onSelect,
  onClose
}) {
  if (!open) return null;

  return (
    <div style={overlayStyle}>
      <div style={modalStyle}>
        <h3>Select Size</h3>

        {item && <p>{item.item_name}</p>}

        <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
          {sizes.map(sz => (
            <button
              key={sz.size_id}
              onClick={() => onSelect(sz)}   // ✅ FIX HERE
              style={btnStyle}
            >
              {sz.size_name} ₹{sz.price}
            </button>
          ))}
        </div>

        <button onClick={onClose} style={{ marginTop: 15 }}>
          Cancel
        </button>
      </div>
    </div>
  );
}

/* ===== STYLES ===== */

const overlayStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  background: "rgba(0,0,0,0.5)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 1000
};

const modalStyle = {
  background: "#fff",
  padding: 20,
  borderRadius: 8,
  width: 320,
  textAlign: "center"
};

const btnStyle = {
  padding: "10px 14px",
  border: "1px solid #ccc",
  borderRadius: 6,
  cursor: "pointer"
};
